var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"directoryBox"},[(_vm.isOld === true)?_c('horizontalDirectory',{ref:"horizontalDirectory"}):_vm._e(),(_vm.isOld === false)?_c('treeLevelDirectory',{ref:"treeLevelDirectory"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }